import { NavLink } from './LinkStyled';

const Link = ({ path, label }) => {
  return (
    <NavLink to={path} className={({ isActive }) => (isActive ? 'active' : '')}>
      {label}
    </NavLink>
  );
};

export default Link;
